import { render, staticRenderFns } from "./Gestation.report.vue?vue&type=template&id=389e9420&scoped=true&"
import script from "./Gestation.report.vue?vue&type=script&lang=js&"
export * from "./Gestation.report.vue?vue&type=script&lang=js&"
import style0 from "./Gestation.report.vue?vue&type=style&index=0&id=389e9420&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389e9420",
  null
  
)

export default component.exports